(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["message-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('busybox-message-carousel')) {
    customElements.define(
      'busybox-message-carousel',
      class BusyBoxMessageCarousel extends HTMLElement {
        connectedCallback() {
          this.onVisibilityChange = this.onVisibilityChange.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);
          this.onBlockDeselect = this.onBlockDeselect.bind(this);

          document.addEventListener('visibilitychange', this.onVisibilityChange);

          if (window.Shopify?.designMode) {
            document.addEventListener('shopify:block:select', this.onBlockSelect);
            document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
          }

          this.onVisibilityChange();
        }

        disconnectedCallback() {
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        }

        onVisibilityChange() {
          this.toggleAttribute('data-document-hidden', document.hidden);
        }

        onBlockSelect(event) {
          if (event.detail.sectionId !== this.dataset.sectionId) return;

          this.setAttribute('data-editor-mode', '');
          this.setAttribute('data-editor-paused', '');

          requestAnimationFrame(() => {
            event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          });
        }

        onBlockDeselect(event) {
          if (event.detail.sectionId !== this.dataset.sectionId) return;

          this.removeAttribute('data-editor-mode');
          this.removeAttribute('data-editor-paused');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
